import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

const LABEL = { corrected: "Corrected", locked: "Locked", unlocked: "Unlocked", added: "Added" };
const seats = (s) => (s ? `${s.won} won${s.leading != null ? `, ${s.leading} leading` : ""}` : "—");

export const ResultsHistory = ({ liveId, board }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/admin/live/${liveId}/country/results/history`).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, [liveId, board]);
  if (!items) return null;
  return (
    <Collapsible className="rounded-xl border border-dashed border-amber-300 bg-amber-50/40 p-3" data-testid="results-history">
      <CollapsibleTrigger className="flex w-full items-center gap-2 text-left text-sm font-semibold" data-testid="results-history-toggle">
        <History size={15} className="text-amber-700" />Admin: correction history<span className="ml-auto text-xs font-normal text-slate-500" data-testid="results-history-count">{items.length} change{items.length === 1 ? "" : "s"}</span>
      </CollapsibleTrigger>
      <CollapsibleContent>
        {items.length === 0 ? <p className="mt-2 text-xs text-slate-500" data-testid="results-history-empty">No seat corrections yet.</p> : (
          <div className="mt-2 overflow-x-auto"><table className="w-full min-w-[520px] text-xs">
            <thead><tr className="text-left uppercase tracking-wider text-slate-400"><th className="py-1 font-medium">When</th><th className="font-medium">Who</th><th className="font-medium">Change</th><th className="font-medium">Before</th><th className="font-medium">After</th></tr></thead>
            <tbody>{items.map((r) => (
              <tr key={r.id} className="border-t border-amber-200/70 align-top" data-testid={`results-history-row-${r.id}`}>
                <td className="whitespace-nowrap py-1.5 pr-2 text-slate-500">{fmtDate(r.at)}</td>
                <td className="py-1.5 pr-2 font-medium">{r.by_name}</td>
                <td className="py-1.5 pr-2"><b>{LABEL[r.action] || r.action}</b> {r.party} · {r.chamber}</td>
                <td className="whitespace-nowrap py-1.5 pr-2 text-slate-500">{seats(r.before)}</td>
                <td className="whitespace-nowrap py-1.5">{seats(r.after)}</td>
              </tr>))}</tbody></table></div>
        )}
      </CollapsibleContent>
    </Collapsible>
  );
};
